import React from 'react';
import { motion } from 'framer-motion';

interface ContactInfoSectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  descriptionAr?: string;
  descriptionEn?: string;
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  language = 'ar',
  titleAr = 'معلومات الاتصال',
  titleEn = 'Contact Information',
  descriptionAr = 'يمكنك التواصل معنا عبر الهاتف أو البريد الإلكتروني أو زيارة مقرنا',
  descriptionEn = 'You can contact us by phone, email, or visit our headquarters'
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-8">
            {isRTL ? titleAr : titleEn}
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            {isRTL ? descriptionAr : descriptionEn}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection; 